import { VisitRequestWorkflowStep } from '@/types/graphql';
import { ChipProps } from '@mui/material';
import lightBlue from '@mui/material/colors/lightBlue';

import { TEXT_GRAY } from '../../constants/colors';
import {
    renderVisitRequestWorkflowStep,
    renderVisitRequestWorkflowStepAsAction,
} from '../../types/visitRequest';
import { StatusOrOutcomeChip } from '../visits/StatusAndOutcomeChips';

const stepColorMapping: Record<VisitRequestWorkflowStep, string> = {
    NEEDS_SERVICES: lightBlue[800],
    NEEDS_CLINICIAN: lightBlue[600],
    NEEDS_TENTATIVE_DATE: lightBlue[400],
    READY_FOR_PROMOTION: lightBlue[200],
    COMPLETED: TEXT_GRAY,
    UNKNOWN: TEXT_GRAY,
};

export const VisitRequestWorkflowStepChip = ({
    workflowStep,
    onClick,
    asAction = false,
    ...rest
}: {
    workflowStep: VisitRequestWorkflowStep;
    onClick?: () => void;
    asAction?: boolean;
} & Omit<ChipProps, 'label' | 'color'>) => {
    return (
        <StatusOrOutcomeChip
            label={
                asAction
                    ? renderVisitRequestWorkflowStepAsAction(workflowStep)
                    : renderVisitRequestWorkflowStep(workflowStep)
            }
            color={stepColorMapping[workflowStep]}
            onClick={onClick}
            {...rest}
        />
    );
};
